let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fYPBk")).then(() => parcelRequire('7A4UJ'));